var map = {
	"./1_FeliErnst_Dandy_anteojos_fotografia_1U0A2349.webp": "./src/img/brands/dandy/1_FeliErnst_Dandy_anteojos_fotografia_1U0A2349.webp",
	"./FeliErnst_Dandy_anteojos_fotografia_1U0A2681.webp": "./src/img/brands/dandy/FeliErnst_Dandy_anteojos_fotografia_1U0A2681.webp",
	"./FeliErnst_Dandy_anteojos_fotografia_1U0A3031.webp": "./src/img/brands/dandy/FeliErnst_Dandy_anteojos_fotografia_1U0A3031.webp",
	"./FeliErnst_Dandy_anteojos_fotografia_1_.webp": "./src/img/brands/dandy/FeliErnst_Dandy_anteojos_fotografia_1_.webp",
	"./FeliErnst_Dandy_anteojos_fotografia_7.webp": "./src/img/brands/dandy/FeliErnst_Dandy_anteojos_fotografia_7.webp",
	"./FeliErnst_Dandy_anteojos_fotografia__U0A2102.webp": "./src/img/brands/dandy/FeliErnst_Dandy_anteojos_fotografia__U0A2102.webp",
	"./FeliErnst_Dandy_anteojos_fotografia__U0A2483.webp": "./src/img/brands/dandy/FeliErnst_Dandy_anteojos_fotografia__U0A2483.webp",
	"./FeliErnst_Dandy_anteojos_fotografia_director_cine6.webp": "./src/img/brands/dandy/FeliErnst_Dandy_anteojos_fotografia_director_cine6.webp"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/img/brands/dandy sync \\.(webp%7Cjpg%7Cjpeg%7Cpng)$";